var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M42.2071 8.20711C42.5976 7.81658 42.5976 7.18342 42.2071 6.79289L35.8431 0.428932C35.4526 0.0384078 34.8195 0.0384078 34.4289 0.428932C34.0384 0.819457 34.0384 1.45262 34.4289 1.84315L40.0858 7.5L34.4289 13.1569C34.0384 13.5474 34.0384 14.1805 34.4289 14.5711C34.8195 14.9616 35.4526 14.9616 35.8431 14.5711L42.2071 8.20711ZM0.5 8.5H41.5V6.5H0.5V8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.59c69eb9f98256ac032a44dfea00f185.svg";
export { ForwardRef as ReactComponent };